const positions = new Map();

export function getPageScrollTop() {
  if (typeof window === "undefined") return 0;
  return window.scrollY || document.documentElement?.scrollTop || 0;
}

export function setPageScrollTop(top) {
  if (typeof window === "undefined") return;
  const y = Math.max(0, Number(top) || 0);
  window.scrollTo(0, y);
}

export function saveTabScroll(tabId) {
  if (!tabId) return;
  positions.set(tabId, getPageScrollTop());
}

export function restoreTabScroll(tabId) {
  const saved = positions.get(tabId);
  setPageScrollTop(typeof saved === "number" ? saved : 0);
}

export function clearTabScroll(tabId) {
  if (!tabId) return;
  positions.delete(tabId);
}

export function clearAllTabScroll() {
  positions.clear();
}

export function disableBrowserScrollRestoration() {
  if (typeof window === "undefined" || !window.history) return;
  try {
    window.history.scrollRestoration = "manual";
  } catch (error) {
    // Some environments expose history without a writable scrollRestoration.
  }
}
